import { render } from "./RadioInput.vue?vue&type=template&id=703e6dca&scoped=true&ts=true&lang=pug"
import script from "./RadioInput.vue?vue&type=script&lang=ts"
export * from "./RadioInput.vue?vue&type=script&lang=ts"

import "./RadioInput.vue?vue&type=style&index=0&id=703e6dca&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703e6dca"]])

export default __exports__